<template lang="pug">
  v-container(:class="{ 'py-2 px-0': isChatHistory, 'radio-offset': isBulkTexts }")
    custom-number-dialog(
      :value="showSelectCustomNumberDialog"
      @close="showSelectCustomNumberDialog = false"
    )
    register-brand-modal(
      :value="showRegisterBrandModal"
      :no-skip="true"
      :new-version="true"
      @close="onCloseRegisterBrandModal"
    )
    sms-compliance-blocked-dialog(
      :value="showSmsComplianceBlockedDialog"
      @close="showSmsComplianceBlockedDialog = false"
    )
    sole-prop-flow-modal
    v-layout
      v-flex.px-0(d-flex)
        v-dialog(v-model="sendingOptionDialog" persistent max-width="610")
          v-card
            v-card-title.primary.widget-title Confirm Sending Options
            v-card-text(v-if="isSendingOptionImmediate") Sending text immediately once
            v-card-text(v-if="isSendingOptionScheduled || isSendingOptionRecurring") Sending text on {{ selectedDateFormatted }} at {{ sendingScheduleTime }}
            v-card-text(v-if="isSendingOptionRecurring") Sending text with intervals of {{ sendRecurring ? sendRecurring.name : '' }}
            v-card-actions
              v-spacer
              v-btn(@click="toggleOpenDialog" flat) Cancel
              v-btn.primary(
                @click="handleSendSms('should send original sms')"
                :disabled="isHandlingSMSSending"
                flat
              ) Send

        v-container.pa-0(fluid)
          v-layout(row wrap)
            v-flex.px-0(xs12)
              v-radio-group.justify-radio(v-model="sendOptionRadioValue" row)
                v-spacer
                v-radio(:key="1" :value="1" label="Immediately")
                v-radio(:key="2" :value="2" label="Scheduled")
                v-radio(v-show="hasBulkTextsAccess" :key="3" :value="3" label="Scheduled and Recurring")
                v-spacer

            v-flex(xs12 px-2 v-if="isSendingOptionScheduled || isSendingOptionRecurring")
              span Sending Schedule
              v-layout(wrap style="margin: auto 0")
                v-flex(:class="inputSize")
                  v-menu(
                    ref="calendarMenu"
                    :close-on-content-click="false"
                    v-model="sendScheduleCalendarPopup"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  )
                    v-text-field(
                      v-model="initialDateRaw"
                      slot="activator"
                      label="Date"
                      prepend-icon="event"
                      readonly
                    )
                    v-date-picker(
                      v-model="initialDateRaw"
                      @input="$refs.calendarMenu.save(initialDateRaw)"
                      :min="minDate"
                      no-title
                    )
                v-flex(:class="inputSize")
                  v-combobox(
                    v-model="initialTime"
                    label="Time"
                    prepend-icon="access_time"
                    :items="timeSlots()"
                    :rules="timeRules"
                  )
            v-flex(xs12 v-if="isSendingOptionRecurring")
              span Recurring Schedule
              v-container(pa-0 fluid)
                recurrence-picker(
                  v-model="sendRecurring"
                  :initialDate="initialDateParsed"
                  :inputSize="recurrenceInputSize"
                )

          v-layout
            v-flex(v-if="showSend" d-flex)
              v-card(flat)
                v-layout(justify-end :class="padding")
                  v-btn.primary.ld-gated-feature(
                    v-if="gatedAction === gatedActions.ComplianceViolationBlocked"
                    slot="activator"
                    :disabled="isDisabled"
                    @click="showSmsComplianceBlockedDialog = true"
                  ) {{ buttonLabel }}
                  ld-gated-button.primary(
                    v-else-if="gatedAction === gatedActions.NoAction"
                    :feature="LdFeatures.TextMessaging"
                    :disabled="isDisabled"
                    :usage="toSelected.length"
                    @click="onSendClick"
                  ) {{ buttonLabel }}
                  v-btn.primary.ld-gated-feature(
                    v-else-if="gatedAction === gatedActions.SetCustomNumber"
                    :disabled="isDisabled"
                    @click="showSelectCustomNumberDialog = true"
                  ) {{ buttonLabel }}
                  v-btn.primary(
                    v-else-if="gatedAction === gatedActions.Register10DLC && shouldSendLeadsPlus"
                    :disabled="isSendButtonDisabled"
                    @click="onPending10DLCSend()"
                  ) Send
                  v-btn.primary.ld-gated-feature(
                    v-else-if="gatedAction === gatedActions.Register10DLC"
                    :disabled="isDisabled"
                    @click="onPending10DLCSend()"
                  ) {{ buttonLabel }}
                  v-btn.primary.ld-gated-feature(
                    v-else-if="gatedAction === gatedActions.Blocked"
                    :disabled="true"
                  ) {{ buttonLabel }}                  
    liondesk-dialog(
      v-model="hasPhishingError"
      width="480"
      hideCancelButton
      ok-button-text="Ok"
      :dialogTitle="phishingDialogTitle"
      :dialogBody="phishingDialogBody"
      @click:ok="togglePhishingError"
    )
</template>

<script>
import dateFns from 'date-fns';
import { mapActions, mapState, createNamespacedHelpers } from 'vuex';
import { timeSlots, timeRules } from '@/Core/utilities';
import { currentDate, formatDate, afterYesterday, split12Time } from '@/Core/filters/dates';
import RecurrencePicker from '@/Communications/components/RecurrencePicker';
import { SEND_OPTIONS } from '@/Communications/config';
import { LdGatedButton, LdFeatures } from 'lion-vue';
import Media from '@/Media/mixins/media';
import CustomNumberDialog from '@/Core/components/CustomNumberDialog';
import RegisterBrandModal from '@/Core/components/RegisterBrandModal';
import SolePropFlowModal from '@/Core/components/SolePropFlowModal';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import sendSMSGate from '@/Core/mixins/send-sms-gate';
import { GATED_ACTIONS } from '@/Core/config/gated-actions';
import { NOT_REQUESTED, APPROVED, PENDING, DENIED, IS_BULK } from '../config';
import { REGISTRATION_STATES } from '../config/registrationStatus';
import { EventBus } from '@/event-bus';
import { STEPS_SOLE_PROPRIETOR } from '@/a2p/config';
import { soleProprietor } from '@/Text/config/consoleSteps';
import {
  ES_STATUS
} from '@/Contacts/config/profile-optin-status'

const { mapActions: mapConversationsActions, mapState: mapConversationsState } =
  createNamespacedHelpers('conversations');

const { mapState: mapRecipientsState } = createNamespacedHelpers('recipients');

const { mapState: mapTemplatesState } = createNamespacedHelpers('templates');

const { mapState: mapUserInformationState, mapGetters: mapUserInformationGetters } =
  createNamespacedHelpers('userInformation');

const { mapState: mapPaymentState, mapActions: mapPaymentActions } = createNamespacedHelpers('payment');

const { mapActions: mapSoleProprietorActions, mapState: mapSoleProprietorState } =
  createNamespacedHelpers('registerSoleProprietorA2p');

const { mapState: mapUserSmsErrorRatesState } = createNamespacedHelpers(
  'userSmsErrorRates',
);

const sendRecurringBaseCase = {
  name: null,
  recurrenceRule: null,
  startDate: null,
};

const solePropCloseAction = 'text-options';

const SmsComplianceBlockedDialog = () =>
  import(/* webpackChunkName: 'SmsComplianceBlockedDialog' */ '@/Core/components/SmsComplianceBlockedDialog');

export default {
  name: 'TextSendingOptions',
  components: {
    RecurrencePicker,
    LdGatedButton,
    CustomNumberDialog,
    RegisterBrandModal,
    LiondeskDialog,
    SolePropFlowModal,
    SmsComplianceBlockedDialog,
  },
  props: {
    inputSize: {
      default: 'xs6',
      type: String,
    },
    padding: {
      default: '',
      type: String,
    },
    showSend: {
      default: true,
      type: Boolean,
    },
    sendingOptionDialogOut: {
      default: false,
      type: Boolean,
    },
    recurrenceInputSize: {
      default: 'xs12',
      type: String,
    },
    isChatHistory: {
      type: Boolean,
      default: false,
    },
    isBulkTexts: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [Media, sendSMSGate],
  data() {
    return {
      LdFeatures,
      sendingOptionDialog: false,
      sendOptionRadioValue: 1,
      sendScheduleCalendarPopup: false,
      initialDateRaw: currentDate(),
      initialDateParsed: new Date(),
      initialTime: dateFns.format(new Date(), 'h:mm a'),
      timeRules,
      timeSlots,
      sendRecurring: sendRecurringBaseCase,
      afterYesterday,
      sendingScheduleDate: '',
      sendingScheduleTime: '',
      isHandlingSMSSending: false,
      showSelectCustomNumberDialog: false,
      showRegisterBrandModal: false,
      phishingDialogTitle: 'Text Failed To Send',
      phishingDialogBody:
        'Your texting activity has been flagged as potentially malicious. Your ability to send texts has been temporarily suspended. Your original texts have been preserved and will be reviewed promptly by support. If validated, your texts will be sent as normal and appear in your contact log.',
      ORIGINAL_SMS: 'should send original sms',
      SMS_AND_OPT_IN: 'should send opt in',
      confirmSendModalTitle: '',
      singleContactOptInStatus: '',
      bulkContactsOptInStatuses: [],
      optInStatusHeader: {
        isNotRequestedSelected: true,
        isPendingSelected: false,
        isApprovedSelected: false,
        isDeniedSelected: false,
      },
      optInContactsToDisplay: [],
      bulkOptInFootnote: '',
      optInNotRequestedContacts: [],
      optInPendingContacts: [],
      optInApprovedContacts: [],
      optInDeniedContacts: [],
      checkboxSelectAllNotRequested: true,
      checkboxSelectAllPending: false,
      gatedActions: GATED_ACTIONS,
      isBulkMsgBtnSending: false,
      isOptInBtnSending: false,
      showSmsComplianceBlockedDialog: false,
    };
  },
  computed: {
    ...mapState({
      state: state => state.templates.state,
      isSending: state => state.templates.isSending,
      currentUser: state => state.userInformation.user,
      contact: state => state.contact.contactChat,
    }),
    ...mapSoleProprietorState(['registrationModalClose']),
    ...mapUserInformationState(['user']),
    ...mapRecipientsState(['toSelected']),
    ...mapTemplatesState(['body', 'recurrenceRule']),
    ...mapConversationsState([
      'sendingTextInProgress',
      'textMessageElements',
      'has10dlcRegister',
      'hasPhishingError',
      'contactsOptInStatuses',
      'registrationStatus10dlc',
      'registrationDate10dlc',
      'registrationType10dlc',
      'isLeadsPlusUser',
      'isLeadsPlusContact',
      'isRegistration10dlcIncomplete',
    ]),
    ...mapUserInformationGetters(['userHasNylasSend', 'shouldGoToLeadsPlusFlow', 'hasAccessToFeature', 'userHasFeatureFlag']),
    ...mapPaymentState(['addRegisterFeeAddonsSuccess']),
    ...mapUserSmsErrorRatesState([
      'isBlocked',
    ]),
    minDate() {
      return currentDate();
    },
    isSendingOptionImmediate() {
      return this.sendOptionRadioValue === SEND_OPTIONS.Immediate;
    },
    isSendingOptionScheduled() {
      return this.sendOptionRadioValue === SEND_OPTIONS.Scheduled;
    },
    isSendingOptionRecurring() {
      return this.sendOptionRadioValue === SEND_OPTIONS.Recurring;
    },
    selectedDateFormatted() {
      return formatDate(this.initialDateRaw);
    },
    selectedDateParsed() {
      return new Date(this.selectedDateFormatted);
    },
    buttonLabel() {
      switch (this.sendOptionRadioValue) {
        case SEND_OPTIONS.Immediate:
          return 'Send Now';
        case SEND_OPTIONS.Scheduled:
        case SEND_OPTIONS.Recurring:
          return 'Send';
      }
    },
    hasNotOptedInContacts() {
      return this.toSelected.some(item => item.opt_in_status && item.opt_in_status !== ES_STATUS.approved && item.opt_in_status !== ES_STATUS.denied);
    },
    // Conditions where the Send button is disabled
    isDisabled() {
      return (
        !this.body ||
        !this.toSelected.length ||
        this.sendingTextInProgress ||
        !this.isScheduledValid() ||
        !this.isSendRecurringValid() ||
        (this.toSelected.length > 1 && this.isBlocked && this.hasNotOptedInContacts)
      );
    },
    // simplify after Aug 31
    canSendSMS() {
      const limitDate = new Date(2023, 8, 1);
      if (new Date() > limitDate) {
        return this.registrationStatus10dlc === 'campaign_completed';
      }
      const targetDate = new Date(Date.UTC(2023, 6, 20)); // July 20, 2023
      targetDate.setUTCHours(0, 0, 0, 0);
      const userCreatedAt = Date.parse(this.user.created_at);
      return new Date(userCreatedAt) < targetDate;
    },
    shouldSendLeadsPlus() {
      return this.shouldGoToLeadsPlusFlow && this.isLeadsPlusUser && this.isLeadsPlusContact && this.sendOptionRadioValue === SEND_OPTIONS.Immediate;
    },
    hasBulkTextsAccess() {
      return this.hasAccessToFeature(LdFeatures.BulkTexts);
    },
  },

  filters: {
    formatDate,
  },

  watch: {
    toSelected: {
      immediate: true,
      async handler(newValue) {
        if (!newValue) return;
        const mapSelectedContactIds = newValue.map(i => i.id);
        this.checkBulkOptInStatuses(mapSelectedContactIds);
        
        if (newValue.length == 1) {
          await this.checkLeadsPlusContact(newValue[0].id);
        }
      },
    },
    contact: {
      immediate: true,
      async handler(newValue) {
        if (!newValue || !newValue.id) return;
        
        await this.checkLeadsPlusContact(newValue.id);
      },
    },
    contactsOptInStatuses() {
      this.checkOptInStatus();
    },
    initialDateRaw(value) {
      if (value) {
        this.initialDateParsed = new Date(`${value} PST`);
      } else {
        this.initialDateRaw = currentDate();
        this.initialDateParsed = new Date();
      }
    },
    initialDateParsed(value) {
      if (value) {
        this.sendRecurring = sendRecurringBaseCase;
      }
    },
    initialTime(value) {
      if (value && timeRules[0](value) === true) this.sendingScheduleTime = value;
    },
    sendingOptionDialogOut(value) {
      if (value) this.isHandlingSMSSending = false;
      this.sendingOptionDialog = value;
    },
    sendOptionRadioValue(value) {
      this.$emit('change-sending-options', value);
    },
    sendRecurring: {
      handler(value) {
        if (value && value.recurrenceRule && value.startDate) {
          this.setRecurrenceRule(value.recurrenceRule);
          this.sendingScheduleDate = value;
          this.$emit('change-recurrence-rule-valid', this.isSendRecurringValid());
        }
      },
      deep: true,
    },
    addRegisterFeeAddonsSuccess: {
      handler(value) {
        if (!value) { return };
        this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
        this.setShowRegistrationFlowModal({ bool: true, action: this.registrationModalClose });
        this.setAddRegisterFeeAddonsSuccess(false);
      },
    },
  },

  mounted() {
    this.sendingScheduleDate = this.initialDateRaw;
    this.sendingScheduleTime = this.initialTime;
  },

  async created() {
    this.checkOptInStatus();
    if (!this.has10dlcRegister || this.isRegistration10dlcIncomplete) {
      await this.checkFor10dlcRegister();
    }
    await this.getLeadsPlusUserInfo();
    EventBus.$on('sole-prop-modal-close', data => {
      if (data === solePropCloseAction && this.canSendSMS) {
        this.onSendClick();
      }
    });
  },

  methods: {
    ...mapActions('templates', ['setRecurrenceRule']),
    ...mapSoleProprietorActions([
      'setShowRegistrationFlowModal',
      'setStep',
    ]),
    ...mapConversationsActions([
      'sendMessages',
      'checkFor10dlcRegister',
      'togglePhishingError',
      'checkContactsOptInStatuses',
      'getLeadsPlusUserInfo',
      'checkLeadsPlusContact',
    ]),
    ...mapPaymentActions(['setAddRegisterFeeAddonsSuccess']),
    /*
     * Checks if the scheduled option is selected, ensure the user has inputted something
     */
    isScheduledValid() {
      if (this.isSendingOptionScheduled || this.isSendingOptionRecurring) {
        return (
          !!this.initialDateParsed && !!this.initialTime && timeRules[0](this.initialTime) === true
        );
      }
      return true;
    },
    /*
     * Checks if the recurring option is selected, ensure the user has inputted something
     */
    isSendRecurringValid() {
      if (this.isSendingOptionRecurring) {
        return !!this.sendRecurring.recurrenceRule;
      }
      return true;
    },
    toggleOpenDialog() {
      const cloneContactsOptInStatuses = this.cloneArray(this.contactsOptInStatuses);
      cloneContactsOptInStatuses.map(val => {
        val.checked = val.status !== 'denied';
        return val;
      });
      this.optInNotRequestedContacts = this.cloneArray(
        cloneContactsOptInStatuses.filter(v => v.status === NOT_REQUESTED),
      );
      this.optInPendingContacts = this.cloneArray(
        cloneContactsOptInStatuses.filter(v => v.status === PENDING),
      );
      this.optInApprovedContacts = this.cloneArray(
        cloneContactsOptInStatuses.filter(v => v.status === APPROVED),
      );
      this.optInDeniedContacts = this.cloneArray(
        cloneContactsOptInStatuses.filter(v => v.status === DENIED),
      );

      this.$emit('close-sending-dialog');
      this.sendingOptionDialog = !this.sendingOptionDialog;
      this.isHandlingSMSSending = false;
    },
    async handleSendSms(value) {
      this.isHandlingSMSSending = true;
      const sendOptions = { type: 'send_now' };
      if (this.isSendingOptionScheduled) {
        const sendSchedule = this.setTime(this.selectedDateParsed);
        sendOptions.sendSchedule = sendSchedule;
        sendOptions.type = 'scheduled_send';
        sendOptions.schedule = {
          action: 'send_sms_scheduled',
          type: 'single',
          due_at: sendSchedule,
        };
      }
      if (this.isSendingOptionRecurring) {
        const startDate = this.setTime(this.sendRecurring.startDate);
        sendOptions.type = 'recurring_send';
        sendOptions.schedule = {
          action: 'send_sms_scheduled',
          type: 'recurrent',
          due_at: startDate,
          recurrence_rule: this.sendRecurring.recurrenceRule,
        };
      }

      let messagePayload;

      if (this.toSelected.length > 1) {
        let contactsToSend = [];
        let NotRequestedOptIn = [];
        if (value === this.SMS_AND_OPT_IN) {
          this.isOptInBtnSending = true;
          NotRequestedOptIn = this.optInNotRequestedContacts
            .filter(v => v.checked === true)
            .reduce((acc, val) => {
              const newVal = {
                id: val.id,
                should_send_opt_in: true,
                should_send_original_sms: true,
                mobile_phone: val.phone_number,
              };
              return [...acc, newVal];
            }, []);
        }
        if (value === this.ORIGINAL_SMS) {
          this.isBulkMsgBtnSending = true;
          NotRequestedOptIn = this.optInNotRequestedContacts
            .filter(v => v.checked === true)
            .reduce((acc, val) => {
              const newVal = {
                id: val.id,
                should_send_opt_in: false,
                should_send_original_sms: true,
                mobile_phone: val.phone_number,
              };
              return [...acc, newVal];
            }, []);
        }

        const pendingOptIn = this.optInPendingContacts
          .filter(v => v.checked === true)
          .reduce((acc, val) => {
            const newVal = {
              id: val.id,
              should_send_opt_in: false,
              should_send_original_sms: true,
              mobile_phone: val.phone_number,
            };
            return [...acc, newVal];
          }, []);
        const approvedOptIn = this.optInApprovedContacts.reduce((acc, val) => {
          const newVal = {
            id: val.id,
            should_send_opt_in: false,
            should_send_original_sms: true,
            mobile_phone: val.phone_number,
          };
          return [...acc, newVal];
        }, []);

        contactsToSend = [...NotRequestedOptIn, ...pendingOptIn, ...approvedOptIn];

        messagePayload = {
          contacts: contactsToSend,
          body: this.body,
          userTimezone: this.user.timezone,
          sendOptions,
        };
      } else {
        sendOptions.optInSelection = value;
        const contact = {
          ...this.toSelected[0],
          should_send_opt_in: this.SMS_AND_OPT_IN === value,
          should_send_original_sms: this.ORIGINAL_SMS === value,
        };

        messagePayload = {
          contacts: [contact],
          body: this.body,
          userTimezone: this.user.timezone,
          sendOptions,
        };
      }

      const payload = { ...messagePayload, actionName: 'bulk' };

      if (this.showSend) {
        payload.imagesURLs = this.getImagesURLsInSMS(this.textMessageElements.images, this.body);
        if (payload.imagesURLs.length) {
          payload.body = this.body.replace(this.IMAGE_REGEX, '').trim();
        }

        await this.sendMessages(payload);
        this.$emit('click:send');
        this.$emit('close-sending-dialog');
      } else {
        // When sms's are scheduled
        this.$emit('send-message-callback', sendOptions);
      }
      if (this.toSelected.length > 1) {
        const mapSelectedContactIds = messagePayload.contacts.map(i => i.id);
        this.checkBulkOptInStatuses(mapSelectedContactIds);
      }
      this.sendingOptionDialog = false;
    },
    isBulkOnlyAprovedOptInContacts() {
      if (
        this.optInApprovedContacts.length &&
        !this.optInNotRequestedContacts.length &&
        !this.optInPendingContacts.length &&
        !this.optInDeniedContacts.length
      ) {
        return true;
      }
      return false;
    },
    checkAllNotRequested() {
      this.optInNotRequestedContacts = [
        ...this.optInNotRequestedContacts.reduce((acc, val) => {
          val.checked = this.checkboxSelectAllNotRequested;
          return [...acc, val];
        }, []),
      ];
    },
    checkAllPending() {
      this.optInPendingContacts = [
        ...this.optInPendingContacts.reduce((acc, val) => {
          val.checked = this.checkboxSelectAllPending;
          return [...acc, val];
        }, []),
      ];
    },
    setTime(date) {
      const { hour, minutes } = split12Time(this.sendingScheduleTime);
      date.setHours(hour);
      date.setMinutes(minutes);
      return date;
    },
    async checkBulkOptInStatuses(value) {
      // Twilio requirement to check opt-in status
      await this.checkContactsOptInStatuses(value);
      if (this.contactsOptInStatuses.length === 1) {
        this.singleContactOptInStatus = this.contactsOptInStatuses[0].status;
        this.confirmSendModalTitle = this.setConfirmSendModalTitle(this.singleContactOptInStatus);
        return;
      }
      this.singleContactOptInStatus = IS_BULK;
      this.confirmSendModalTitle = this.setConfirmSendModalTitle(this.singleContactOptInStatus);
    },
    async checkOptInStatus() {
      // Twilio requirement to check opt-in status
      if (this.contactsOptInStatuses.length === 1) {
        this.singleContactOptInStatus = this.contactsOptInStatuses[0].status;
        this.confirmSendModalTitle = this.setConfirmSendModalTitle(this.singleContactOptInStatus);
        return;
      }
      this.singleContactOptInStatus = IS_BULK;
      this.confirmSendModalTitle = this.setConfirmSendModalTitle(this.singleContactOptInStatus);
    },
    setConfirmSendModalTitle(value) {
      if (value === NOT_REQUESTED) {
        return `This contact hasn't opted-in to receive sms`;
      }
      if (value === APPROVED) {
        return 'Confirm Sending Options';
      }
      if (value === PENDING) {
        return 'Message to request consent has been sent';
      }
      if (value === DENIED) {
        return 'Contact denied consent for sms messages';
      }
      if (value === IS_BULK) {
        return 'Review status for SMS consent';
      }
    },
    async onSendClick() {
      this.optInNotRequestedContacts = this.cloneArray(
        this.contactsOptInStatuses.filter(v => v.status === 'not_requested'),
      );
      this.setBulkOptInStatusFootnote(NOT_REQUESTED);

      this.toggleOpenDialog();
    },
    onCloseRegisterBrandModal() {
      this.showRegisterBrandModal = false;
      if (this.canSendSMS) {
        this.onSendClick();
      }
    },
    cloneArray(array) {
      const clonedArray = JSON.stringify(array);
      return JSON.parse(clonedArray);
    },
    clickedStatus(value) {
      this.setBulkOptInStatusFootnote(value);

      if (value === NOT_REQUESTED) {
        this.optInStatusHeader.isNotRequestedSelected = true;
        this.optInStatusHeader.isPendingSelected = false;
        this.optInStatusHeader.isApprovedSelected = false;
        this.optInStatusHeader.isDeniedSelected = false;
        return;
      }
      if (value === PENDING) {
        this.optInStatusHeader.isNotRequestedSelected = false;
        this.optInStatusHeader.isPendingSelected = true;
        this.optInStatusHeader.isApprovedSelected = false;
        this.optInStatusHeader.isDeniedSelected = false;
        return;
      }
      if (value === APPROVED) {
        this.optInStatusHeader.isNotRequestedSelected = false;
        this.optInStatusHeader.isPendingSelected = false;
        this.optInStatusHeader.isApprovedSelected = true;
        this.optInStatusHeader.isDeniedSelected = false;
        return;
      }
      if (value === DENIED) {
        this.optInStatusHeader.isNotRequestedSelected = false;
        this.optInStatusHeader.isPendingSelected = false;
        this.optInStatusHeader.isApprovedSelected = false;
        this.optInStatusHeader.isDeniedSelected = true;
        return;
      }
    },
    shouldOptInBtnBeDisabled() {
      if (this.isHandlingSMSSending) {
        return true;
      }
      if (
        this.optInNotRequestedContacts.filter(v => v.checked === true).length &&
        (this.optInNotRequestedContacts.length || this.contactsOptInStatuses.length)
      ) {
        return false;
      }
      return true;
    },
    shouldSendBulkMsgBtnBeDisabled() {
      if (this.isHandlingSMSSending) {
        return true;
      }
      if (
        this.optInApprovedContacts.length ||
        this.optInNotRequestedContacts.filter(v => v.checked === true).length ||
        this.optInPendingContacts.filter(v => v.checked === true).length
      ) {
        return false;
      }
      return true;
    },
    setBulkOptInStatusFootnote(value) {
      if (value === NOT_REQUESTED) {
        this.bulkOptInFootnote =
          'These contacts do not have Opt-In Consent and you have not requested consent yet. To send this group an Opt-In request, choose the first button to send your message.';
        return;
      }
      if (value === PENDING) {
        this.bulkOptInFootnote =
          'These contacts have received an Opt-In request but have not responded. You can choose to send them your message anyway. It will not contain another Opt-In request. We recommend waiting for their opt-in response';
        return;
      }
      if (value === APPROVED) {
        this.bulkOptInFootnote =
          'These contacts have Opt-In Consent andd your message will be sent without Opt-In Request';
        return;
      }
      if (value === DENIED) {
        this.bulkOptInFootnote =
          'These contacts have opted-out of SMS Messaging from you. Text messages to these contacts cannot be sent. You can still contact them by email';
        return;
      }
    },
    handleCheckbox(event) {
      if (event.target._value.status === PENDING) {
        this.optInPendingContacts = [
          ...this.optInPendingContacts.reduce((acc, val) => {
            if (val.id === event.target._value.id) {
              val.checked = event.target.checked;
            }
            return [...acc, val];
          }, []),
        ];
        if (!event.target.checked) {
          this.checkboxSelectAllPending = false;
        }
        return;
      }
      if (event.target._value.status === NOT_REQUESTED) {
        this.optInNotRequestedContacts = [
          ...this.optInNotRequestedContacts.reduce((acc, val) => {
            if (val.id === event.target._value.id) {
              val.checked = event.target.checked;
            }
            return [...acc, val];
          }, []),
        ];
        if (!event.target.checked) {
          this.checkboxSelectAllNotRequested = false;
        }
      }
    },
    async onPending10DLCSend() {
      if (!this.registrationStatus10dlc && !this.isLeadsPlusContact) {
        this.setStep(STEPS_SOLE_PROPRIETOR.DECISION);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        return;
      }

      if (this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_COMPLETED) {
        this.onSendClick();
        return;
      }

      if (this.shouldGoToLeadsPlusFlow && this.isLeadsPlusUser) {
        if (this.toSelected.length > 1) {
          this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
          this.setShowRegistrationFlowModal({ bool: true, action: null });
          return;
        }
        
        if (!this.isLeadsPlusContact || this.sendOptionRadioValue !== SEND_OPTIONS.Immediate) {
          this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
          this.setShowRegistrationFlowModal({ bool: true, action: null });
          return;
        }
        this.onSendClick();
        return;
      }

      if (
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_PENDING ||
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_CAMPAIGN_RETRY_PENDING ||
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_BRAND_RETRY_PENDING
      ) {
        this.setStep(STEPS_SOLE_PROPRIETOR.PAYMENT);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        return;
      }

      if (
        this.canSendSMS && (
          this.registrationStatus10dlc === REGISTRATION_STATES.BRAND_SUBMITTED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_RECEIVED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_SUBMITTED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_PENDING)
      ) {
        return this.onSendClick();
      }

      this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
      this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
    },
  },
};
</script>
<style scoped lang="scss">
.radio-offset {
  margin-right: 48px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.justify-radio {
  justify-content: flex-end;
}

.confirm-send {
  &--text {
    font-size: 13px;
  }
}

.opt-in {
  &--title {
    text-align: center;
    color: var(--v-primary-base);
    font-size: 15px;
  }

  &--text {
    font-size: 13px;
  }

  &--btn {
    width: 220px;
    height: 64px;
    font-size: 13px;
  }

  &--btnTitle {
    font-size: 16px;
    font-weight: 500;
  }

  &--btnSubtitle {
    font-size: 14px;
    font-weight: 500;
  }

  &--btnCaption {
    font-size: 12px;
    width: 200px;
    text-align: center;
  }
}

.bulk-contacts {
  &--container {
    border: 1px solid var(--v-background-lighten4);
  }

  &--header {
    background-color: var(--v-background-lighten4);
    height: 30px;
  }

  &--btn {
    height: 30px;
  }

  &--selected {
    border-bottom: 1px solid var(--v-primary-base);
  }

  &--notSelected {
    border-bottom: none;
  }
}

.status-header {
  &--text {
    font-size: 13px;
    line-height: 0;
  }

  &--selectedText {
    color: var(--v-primary-base);
    font-weight: 600;
  }

  &--notSelectedText {
    color: var(--v-primary-lighten1);
    font-weight: 400;
  }
}

.opt-in-checkbox {
  transform: scale(0.85);
}

.opt-in-listItem {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: start;
}

.opt-in-listText {
  font-size: 13px;
  line-height: 0;
}

.optIn-approved-checkbox {
  font-size: 14px;
  color: var(--v-primary-darken1);
  opacity: 50%;
}

.opt-in-container {
  max-height: 200px;
  overflow: auto;
}
</style>
